import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal, WritableSignal } from '@angular/core';
import { form, FormField, required } from '@angular/forms/signals';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { AgentProfileDto, AgentType } from '@workspace/data-types';
import {
  AbstractSignalFormComponent,
  SelectionCardComponent,
  SelectionCardGroupComponent,
} from '@workspace/ng-aura';

export interface AgentProfileFormModel {
  type: AgentType | null;
}

@Component({
  selector: 'etxe-agent-profile-form',
  standalone: true,
  imports: [
    CommonModule,
    FormField,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,
    MatDatepickerModule,
    SelectionCardComponent,
    SelectionCardGroupComponent,
  ],
  templateUrl: './agent-profile-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentProfileFormComponent extends AbstractSignalFormComponent<
  AgentProfileDto,
  AgentProfileFormModel
> {
  minDate = new Date(new Date().setDate(new Date().getDate() + 1));

  override model: WritableSignal<AgentProfileFormModel> = signal<AgentProfileFormModel>({
    type: null,
  });

  override formTree = form(this.model, (b) => {
    required(b.type);
  });

  protected override buildModelFromDto(dto: AgentProfileDto): AgentProfileFormModel {
    return {
      type: dto?.type ?? null,
    };
  }

  protected override buildDtoFromModel(model: AgentProfileFormModel): AgentProfileDto {
    const dto = this.dto() || ({} as AgentProfileDto);
    return {
      ...dto,
      type: model.type || dto.type,
    } as AgentProfileDto;
  }
}
